import * as React from 'react';
import { observable } from 'mobx';
import { Button } from 'components/widgets/Button';
import { closePopup } from '../../widgets/Popup';
import { observer } from 'mobx-react';
import { TrackersData, ITracker } from 'data/TrackersData';
import { IconChoices } from './IconChoices';
import { ErrorMessage } from 'components/widgets/ErrorMessage';

/**
 * CSS for trackerPopup is in CreateTrackerPopup.pcss
 */

interface SelectTrackerIconPopup_P {
  tracker:ITracker;
}

@observer
export class SelectTrackerIconPopup extends React.Component<SelectTrackerIconPopup_P> {

  @observable iconName:string;
  @observable saving:boolean = false;
  @observable error:boolean = false;
  @observable errorMessage:boolean = false;

  constructor(props:SelectTrackerIconPopup_P) {
    super(props);
    this.iconName = props.tracker.iconName;
  }

  handleClickSave= () => {
    this.error = false;
    let trackerData:ITracker = { ...this.props.tracker, dailyValues:{}, dailyValuesFitbit:{}, iconName:this.iconName };
    TrackersData.updateTracker(trackerData)
    .then(()=>{ closePopup(); })
    .catch(()=>{
      this.error = true;
      this.saving = false;
    });
  }

  render() {
    
    return (
      <div className="trackerPopup selectIcon">
        <h1>Change Icon</h1>
        <div className="popupBody">
          
          {this.error && <ErrorMessage message="Failed to change icon. Please make sure that your Internet connection is stable and try again." /> }

          <h2>Choose an Icon</h2>
      
          <IconChoices iconName={this.iconName} onSelectIcon={(iconName)=>{ this.iconName = iconName;}} />

        </div>
        <div className="popupFooter">
          <Button disabled={this.saving} onClick={this.handleClickSave}>Save</Button>
          <Button disabled={this.saving} cancel flat onClick={closePopup}>Cancel</Button>
        </div>
      </div>
    );   
  }

} 

// interface IconChoices_P {
//   iconName:string;
//   onSelectIcon:StringFunc;
// }

// @observer
// class IconChoices extends React.Component<IconChoices_P> {
//   render() {
//     return (
//       <div className="iconChoices">
//         {customIconList.map((icon, idx)=><IconChoice key={icon} iconName={icon} selectedIconName={this.props.iconName} onSelectIcon={this.props.onSelectIcon} />)}   
//       </div>
//     );
//   }
// }

// interface IconChoice_P {
//   iconName:string;
//   selectedIconName:string;
//   onSelectIcon:StringFunc;
// }
// const IconChoice = (props:IconChoice_P) => 
//   <div className={`iconChoice${props.iconName===props.selectedIconName?' selected':''} noselect`} onClick={()=>{ props.onSelectIcon(props.iconName); }}>
//     <Icon iconName={props.iconName} color="#666666"/>
//   </div>
// ;


// const InputLabel = (props:{label:string, children:any}) =>
//   <div className="inputLabel">
//     <label>{props.label}</label>
//     {props.children}
//   </div>
// ;